const HttpRequestMethod = Object.freeze({
    GET:0,
    POST:1,
    PUT:2,
    DELETE:3,
    0:'GET',
    1:'POST',
    2:'PUT',
    3:'DELETE'
});

export default HttpRequestMethod;